import React from 'react'
import { useTranslation } from 'react-i18next'
import { LayoutBand, Grid, Card, Cell, colors, H2, Paragraph, Separator, useContainerWidth } from '@fs/zion-ui'
import { AuthProviderButtonRow } from '@fs/zion-auth-provider-buttons'
import readyToStartImage from '../assets/ReadyToStart.webp'

export default function ReadyToStartSection(): JSX.Element {
  const { t } = useTranslation()
  const atWidth = useContainerWidth()

  return (
    <LayoutBand color={colors.gray02} maxWidth="xxl" marginY="xxl" marginX={atWidth({ default: 'sm', xl: 'xxl' })}>
      {/* Two-column responsive grid */}
      <Grid gutters={atWidth({ default: 'lg', lg: 'xl' })}>
        {/* Left column: Background image card */}
        <Card
          backgroundImage={readyToStartImage}
          columns={atWidth({ default: 12, xl: 6 })}
          minHeight={atWidth({ default: 250, xl: 400 })}
          edges="elevation"
        >
          {null}
        </Card>

        {/* Right column: Content and CTA */}
        <Cell alignY="middle" columns={atWidth({ default: 12, xl: 6 })}>
          {/* Main heading */}
          <H2 size="H3">
            {t('tree-overview.family-interview.ready.heading', 'Ready to Start Gathering Your Family History?')}
          </H2>

          <Separator size="md" />

          {/* Description paragraph */}
          <Paragraph size="sm">
            {t(
              'tree-overview.family-interview.ready.description',
              'Use these questions to interview your family members, then add the information to your family tree on FamilySearch.'
            )}
          </Paragraph>

          <Separator size="lg" />

          {/* Authentication provider buttons */}
          <AuthProviderButtonRow size="sm" linkNamePrefix="ReadyToStartSection" />
        </Cell>
      </Grid>
    </LayoutBand>
  )
}
